import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import { EditableText } from "../../../util/EditableText";
import { NavigatableText } from "../../../util/NavigatableText";
import { UpdateApiResponse } from "../useUpdateInformation";

interface SummaryInformationProps {
  location: string;
  organizationName: string;
  organizationId: string;
  updateResult: UpdateApiResponse | undefined;
  onSave: (city: string) => Promise<void>;
}

export const SummaryInformation = ({
  location,
  organizationName,
  organizationId,
  updateResult,
  onSave,
}: SummaryInformationProps) => {
  const { t } = useTranslation();

  return (
    <div>
      {updateResult?.status === 400 &&
        updateResult.updatedValue.key === "projectLocation" && (
          <Alert
            message={t("translations:update-location-failed")}
            type="error"
            closable
          />
        )}
      {updateResult?.status === 200 &&
        updateResult.updatedValue.key === "projectLocation" && (
          <Alert
            message={t("translations:update-location-success")}
            type="success"
            closable
          />
        )}
      <table className="summary-table">
        <tbody>
          <tr>
            <td className={"align-right"}>
              {t("translations:created-date")}:&nbsp;&nbsp;
            </td>
            <td>
              {/* {dateCreated.toLocaleString()} */}
              Not available
            </td>
          </tr>
          <tr>
            <td className={"align-right"}>
              {t("translations:location")}:&nbsp;&nbsp;
            </td>
            <td>
              <EditableText
                text={location}
                style={{ height: "20px", width: "300px" }}
                saveCallback={(value) => onSave(value)}
              />
            </td>
          </tr>
          <tr>
            <td className={"align-right"}>
              {t("translations:organization")}:&nbsp;&nbsp;
            </td>
            <td>
              <NavigatableText
                text={organizationName}
                type="router"
                route={`/organizations/${organizationId}`}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
